// Forme sociale de la fiche client ↔ liste « Formes » des Paramètres KYC/LAB.
//
// La fiche stocke historiquement des libellés courts (« E.I », « SARL »…) :
// on garde ce format quand une entrée du référentiel y correspond (E.I ↔ EI),
// pour ne rien changer aux écrans qui lisent formeSociale. Les anciennes
// valeurs absentes du référentiel (LMNP, SEL…) restent choisissables mais
// n'ont aucun effet sur le risque (Risque & vigilance ne les conditionne pas).

export const FORMES_FICHE_HISTORIQUES = [
  "E.I",
  "E.I.R.L",
  "EARL",
  "EURL",
  "SARL",
  "SASU",
  "SAS",
  "SCI",
  "SCM",
  "SCCV",
  "LMNP",
  "GFA",
  "SC",
  "SCP",
  "SEL",
  "N/A",
];

export const codeForme = (valeur) =>
  String(valeur || "")
    .toUpperCase()
    .replace(/[.\s]/g, "");

export const valeurFormeFiche = (formeSociale) =>
  (Array.isArray(formeSociale) ? formeSociale[0] : formeSociale) || "";

// Code du référentiel → valeur enregistrée sur la fiche client.
export function valeurFicheDepuisCode(code) {
  if (!code) return "";
  return FORMES_FICHE_HISTORIQUES.find((v) => codeForme(v) === code) || code;
}

// Options du sélecteur : référentiel (actif) puis anciennes valeurs hors
// référentiel. `formes` = kycReferentiel.listes.formes.
export function optionsFormeSociale(formes, valeurActuelle) {
  const actives = (formes || []).filter((f) => f.etat !== "archive");
  const codes = new Set(actives.map((f) => f.code));
  const referentiel = actives.map((f) => ({
    value: valeurFicheDepuisCode(f.code),
    label: `${f.code} — ${f.libelle}`,
  }));
  const hors = FORMES_FICHE_HISTORIQUES.filter((v) => !codes.has(codeForme(v)));
  const toutes = new Set([...referentiel.map((o) => o.value), ...hors]);
  if (valeurActuelle && !toutes.has(valeurActuelle)) hors.push(valeurActuelle);
  return { referentiel, hors };
}
